import { FormErrors } from "redux-form";
import moment from "moment";

import { required, lessThanOrEqual } from "../../../../util/validators";
import { IWithdrawalRequestFormData } from "../withdrawalRequestForm";
import { numericCommaStringToDecimal } from "../../../../util/numericTransformation";

const validateWithdrawalRequestForm = (values: IWithdrawalRequestFormData) => {
    const errors: FormErrors<IWithdrawalRequestFormData> = {};

    errors.accountNumber = required(values.accountNumber);
    errors.amount = required(values.amount);

    if (numericCommaStringToDecimal(values.amount) <= 0) {
        errors.amount = "Määrän tulee olla suurempi kuin 0 €";
    }

    if (!values.contactByEmail && !values.contactByPhone) {
        errors.contactByEmail = required(values.contactByEmail);
        errors.contactByPhone = required(values.contactByPhone);
    }

    return errors;
};

export default validateWithdrawalRequestForm;



// WEBPACK FOOTER //
// ./src/views/account/components/validate/WithdrawalRequestFormValidator.tsx